import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/wcandillon/tmp/tmp/react-native-redash/packages/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "arrays"
    }}>{`Arrays`}</h1>
    <h2 {...{
      "id": "get"
    }}><inlineCode parentName="h2">{`get()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const get: (array: Animated.Adaptable<number>[], index: Animated.Adaptable<number>, notFound?: Animated.Node<number>) => Animated.Node<number>;
`}</code></pre>
    <h2 {...{
      "id": "contains"
    }}><inlineCode parentName="h2">{`contains()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const contains: (values: Animated.Adaptable<number>[], value: Animated.Adaptable<number>) => Animated.Node<0 | 1>;
`}</code></pre>
    <h2 {...{
      "id": "find"
    }}><inlineCode parentName="h2">{`find()`}</inlineCode></h2>
    <pre><code parentName="pre" {...{
        "className": "language-tsx"
      }}>{`const find: (values: Animated.Node<number>[], fn: (v: Animated.Node<number>) => Animated.Node<number>, notFound?: Animated.Node<number>) => Animated.Node<number>;
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      